export { default } from './JournalArticle';
